import api from './api';

export const getNotifications = async ({
  groupCode,
  cursor,
  limit = 20,
  registeredAt,
}) => {
  try {
    const response = await api({
      method: 'GET',
      url: '/notifications',
      params: {
        groupCode,
        limit,
        ...(cursor && { cursor }),
        ...(registeredAt && { registeredAt }),
      },
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const markNotificationRead = async (notificationId) => {
  try {
    const response = await api({
      method: 'POST',
      url: `/notifications/${notificationId}/read`,
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const markAllNotificationsRead = async (groupCode) => {
  try {
    const response = await api({
      method: 'POST',
      url: '/notifications/read',
      data: {
        groupCode,
      },
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};

export const getGroupsReadStatus = async () => {
  try {
    const response = await api({
      method: 'GET',
      url: '/notifications/read/group-code',
    });
    return response;
  } catch (err) {
    return err.response?.data;
  }
};
